import {PlayerImageType} from "modules/enums";
import React, {useEffect, useState} from "react";
import {ImageHandler} from "modules/utils/helpers/ImageHandler";
import {IPlayer, Nullable, NullOrEmpty} from "modules/types";
import styled from "@emotion/styled";
import {Preloader} from "components/Preloader";
import {getDashedValue} from "modules/utils/helpers";

const ImageElement = styled.img`
	pointer-events: none;
`;

const imageMapper = {
	[PlayerImageType.headshot]: ImageHandler.getPlayerAvatar,
	[PlayerImageType.actionShotImage]: ImageHandler.getPlayerActionShotImage,
	[PlayerImageType.actionFullImage]: ImageHandler.getPlayerActionFullImage,
};

interface IProps {
	type: PlayerImageType;
	player: NullOrEmpty<IPlayer>;
}

export const PlayerImage: React.FC<IProps> = ({type, player}) => {
	const [link, setLink] = useState<Nullable<string>>(null);
	const [isLoading, setIsLoading] = useState<boolean>(true);

	useEffect(() => {
		if (!player) {
			return;
		}
		void (imageMapper[type](player) as Promise<string>)
			.then((url) => {
				setLink(url);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, [player, type]);

	if (isLoading) {
		return <Preloader />;
	}

	if (!link) {
		return null;
	}

	return (
		<ImageElement
			className={"player-image"}
			src={link}
			alt={`${getDashedValue(player?.firstName)} ${getDashedValue(
				player?.lastName
			)} - ${type}`}
		/>
	);
};
